import Configurator from "./components/Configurator.vue";
import "./plugins/vuetify";
import { defineComponent } from "vue";
import config, { setCustomConfig } from "./config/custom-config";
export default defineComponent({
  name: "App",
  components: {
    Configurator
  },
  data() {
    return {
      appDark: false,
      username: "",
      password: "",
      passwordVisible: false,
      loginError: false,
      loginMsg: "",
      loginLoading: false,
      authReady: false
    };
  },
  async mounted() {
    window.addEventListener("message", this.onMessage);
    document.documentElement.style.setProperty("--template-base-primary", config.icon_color);
    // @ts-ignore
    this.$vuetify.theme.themes.light.primary = config.icon_color;
    try {
      await this.$store.dispatch("configurator/user/getUserData");
    } finally {
      this.authReady = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  computed: {
    itemsLoaded() {
      return this.$store.state.itemsLoaded;
    },
    isLoginRequired() {
      return Boolean(config.login_required);
    },
    userIsGuest() {
      return this.$store.getters["configurator/user/isGuest"];
    },
    showAuthLoader() {
      return this.isLoginRequired && !this.authReady;
    },
    showInitialLogin() {
      return this.isLoginRequired && this.authReady && this.userIsGuest;
    }
  },
  methods: {
    onMessage(event) {
      if (!event.data || typeof event.data !== "object") return;
      if (event.data.type !== "TEMPLATE_BASE_SET_CONFIG") return;
      if (!event.data.config || typeof event.data.config !== "object") return;
      setCustomConfig(event.data.config);
      if (event.data.config.icon_color) {
        document.documentElement.style.setProperty("--template-base-primary", event.data.config.icon_color);
        // @ts-ignore
        this.$vuetify.theme.themes.light.primary = event.data.config.icon_color;
      }
      if (event.data.config.btn_menu_color) {
        // @ts-ignore
        this.$vuetify.theme.themes.light.secondary = event.data.config.btn_menu_color;
      }
    },
    async submitLogin() {
      if (!this.username || !this.password) return;
      this.loginLoading = true;
      this.loginError = false;
      this.loginMsg = "";
      try {
        const response = await this.$store.dispatch("configurator/user/login", {
          username: this.username,
          password: this.password
        });
        const loginRes = (response === null || response === void 0 ? void 0 : response.data) || {};
        this.loginError = Boolean(loginRes.error);
        this.loginMsg = loginRes.msg || "";
      } catch (error) {
        this.loginError = true;
        this.loginMsg = "Errore durante il login";
      } finally {
        this.loginLoading = false;
      }
    }
  },
  watch: {
    appDark(val) {
      //@ts-ignore
      this.$vuetify.theme.dark = val;
    },
    itemsLoaded: {
      immediate: true,
      handler(loaded) {
        if (loaded) {
          this.$store.commit("setMarchio", "ULTEMATE");
        }
      }
    }
  }
});